import axios from 'axios';

const axiosInstance = axios.create({
  // baseURL: 'http://localhost:3005',
  baseURL: 'https://internalapi.value360india.com', 
  // timeout: 4000
});

export default axiosInstance;